<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<goods-tag-cell :row="row" ref="goodsTagCell" auth="my-talent:tags:set-anchor-tags" :editTag="true" />
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import goodsTagCell from '@/components/tableCells/goodsTagCell.vue';
export default {
	components: {
		goodsTagCell,
	},
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
</style>
